<template>
  <div class="options__wrapper">
    <ul class="options">
      <li
        :class="{ active: isActive(option) }"
        v-for="option in list"
        :key="option.id || option"
        @click="onSelect(option)"
      >
        <div class="options__checkbox">
          <SvgIcon name="checkbox" />
        </div>
        <div class="options__text">{{ option.title || option }}</div>
      </li>
    </ul>
    <textarea
      class="options__textarea"
      v-if="yourAnswer && yourAnswerSelected"
      @input="inputYourAnswer($event.target.value)"
    ></textarea>
  </div>
</template>

<script>
import { SvgIcon } from '@/components/ui'
const YOUR_ANSWER_TEXT = 'Your answer'

export default {
  components: { SvgIcon },
  props: {
    options: {
      type: Array,
      required: true,
    },
    yourAnswer: Boolean,
    selected: [String, Number],
  },
  data: () => ({
    yourAnswerSelected: false,
  }),
  computed: {
    list() {
      if (this.yourAnswer) {
        return [...this.options, YOUR_ANSWER_TEXT]
      } else {
        return this.options
      }
    },
  },
  methods: {
    onSelect(option) {
      if (option === YOUR_ANSWER_TEXT) {
        this.yourAnswerSelected = true
        this.$emit('onSelect', '')
      } else {
        this.yourAnswerSelected = false
        this.$emit('onSelect', option?.id ?? option)
      }
    },
    isActive(option) {
      if (option === YOUR_ANSWER_TEXT) {
        return this.yourAnswerSelected
      } else {
        const val = option?.id ?? option
        return this.selected === val
      }
    },
    inputYourAnswer(value) {
      if (this.yourAnswerSelected) {
        this.$emit('onSelect', value)
      }
    },
  },
  watch: {
    options() {
      this.yourAnswerSelected = false
    },
  },
}
</script>

<style lang="scss" scoped>
.options {
  margin: 36px 0;
  padding: 0;
  display: flex;
  flex-direction: column;

  &__wrapper {
  }

  &__textarea {
    width: 100%;
  }

  &__checkbox {
    position: relative;
    flex: 0 0 20px;
    width: 20px;
    height: 20px;
    background: #f1f3f5;
    border-radius: 3px;
    margin-right: 16px;
    transition: background 0.25s $ease;
    .svg-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 6px;
      color: white;
      opacity: 0;
      transform: scale(1) translate(-50%, -50%);
      will-change: transform;
      transition: 0.25s $ease;
    }
  }
  &__text {
    display: inline-block;
  }
  li {
    display: inline-flex;
    align-items: center;
    padding: 10px 14px;
    font-size: 14px;
    margin-bottom: 10px;
    border: 1px solid #f1f3f5;
    border-radius: 5px;
    cursor: pointer;
    transition: border 0.25s $ease, color 0.25s $ease;
    &:last-child {
      margin-bottom: 0;
    }
    &.active {
      border-color: $primary;
      color: $primary;
      font-weight: bold;
      .options__checkbox {
        background: $primary;
        .svg-icon {
          opacity: 1;
          transform: translate(-50%, -50%);
        }
      }
    }
    &:hover {
      border-color: $primary;
      // color: $primary;
    }
  }
}
</style>
